import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function servicesActsReducer() {
  return combineReducers({
    servicesActsList: createItemReducer("ServicesActs", "VendReceiptTransportWeb.Edit", false),
    servicesActsListParams: createItemReducerParams("ServicesActs", "VendReceiptTransportWeb.Edit"),
    servicesActsCreate: createItemReducer("ServicesActs", "VendReceiptTransportWeb.Create", false),
    servicesActsCreateParams: createItemReducerParams("ServicesActs", "VendReceiptTransportWeb.Create"),
    servicesActsSend: createItemReducer("ServicesActs", "VendReceiptTransportWeb.Send", false),
    servicesActsDelete: createItemReducer("ServicesActs", "VendReceiptTransportWeb.Delete", false),
    servicesActsUpdate: createItemReducer("ServicesActs", "VendReceiptTransportWeb.Update", false),
    servicesActsUpdateParams: createItemReducerParams("ServicesActs", "VendReceiptTransportWeb.Update"),

    servicesActDescribe: createItemReducer("ServicesActs", "VendReceiptTransportWeb.Edit/ActEditDescribe", false),
    servicesActPLList: createItemReducer("ServicesActs", "VendReceiptTransportWeb.ViewPL", false),
    servicesActPLListParams: createItemReducerParams("ServicesActs", "VendReceiptTransportWeb.ViewPL"),
    servicesActPLLinkedList: createItemReducer("ServicesActs", "VendReceiptTransportWeb.EditPL", false),
    servicesActPLInsertList: createItemReducer("ServicesActs", "VendReceiptTransportWeb.InsertPL", false),
    servicesActPLDeleteList: createItemReducer("ServicesActs", "VendReceiptTransportWeb.DeletePL", false)
  });
}